import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./kiosk_payment_terminal_state.js";
//#region src/kiosk_payment_terminal_state_helper.ts
var kiosk_payment_terminal_state_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(paymentTerminalState) {
	switch (paymentTerminalState) {
		case 0: return "stopped";
		case 1: return "initializing";
		case 2: return "terminal selection";
		case 3: return "waiting for terminal";
		case 4: return "terminal connecting";
		case 5: return "updating";
		case 6: return "ready";
		case 7: return "transaction";
	}
}
//#endregion
export { kiosk_payment_terminal_state_helper_exports, name };

//# sourceMappingURL=kiosk_payment_terminal_state_helper.js.map